<template>
  <section class="subscribe">
    <div class="container">
      <div class="subscribe__wrapper">
        <div class="subscribe__content">
          <h2 class="subscribe__title title">
            подпишитесь на&nbsp;наши соц сети
          </h2>
          <div class="subscribe__info">
            Чтоб получать самую актуальную информацию
          </div>
          <div class="subscribe__social">
            <NuxtLink
              class="subscribe__link"
              to="https://t.me/sharunstore"
              target="_blank"
            >
              <DefIcon name="tg" />
            </NuxtLink>
            <NuxtLink
              class="subscribe__link pnt"
              to="https://ru.pinterest.com/sharunstore/"
              target="_blank"
            >
              <DefIcon name="pnts" />
            </NuxtLink>
            <NuxtLink
              class="subscribe__link ytb"
              to="https://www.youtube.com/@sharun-store"
              target="_blank"
            >
              <DefIcon name="youtube" />
            </NuxtLink>
            <NuxtLink
              class="subscribe__link"
              to="https://dzen.ru/sharunstore"
              target="_blank"
            >
              <DefIcon name="dzen" />
            </NuxtLink>
          </div>
        </div>
        <div class="subscribe__image">
          <img
            class="desktop"
            src="~/assets/img/social-.jpg"
            alt="background"
          />
          <img
            class="tablet"
            src="~/assets/img/social-s-.jpg"
            alt="background"
          />
          <img
            class="mobile"
            src="~/assets/img/social-mobile-.jpg"
            alt="background"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import DefIcon from "~/components/UI/Icons/DefIcon.vue";
</script>
